import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getFormValues, arrayRemoveAll, arrayPush } from 'redux-form';
import * as actItem from 'actions/library/item';
import styles from './TypeFieldArrayEcommerce.css';

class TypeFieldArrayEcommerce extends Component {
  constructor() {
    super();
    this.state = {
      selectedColor: null,
      selectedSize: null,
      selectedMaterial: null,
    };
  }

  _handleInputChange = (e, type) => {
    const { value } = e.target;
    const { dispatch } = this.props;

    const actionType = `setCustomCategoryFashion${type}Input`;
    dispatch(actItem[actionType](value));
  };

  _handleInputKeyDown = (e, labelName, pluralName, onBlur) => {
    const { dispatch, customCategoriesEcommerceFashionData } = this.props;
    const { value } = e.target;

    // if user press enter
    if (e.keyCode === 13 || (e.keyCode === 188 && !e.shiftKey) || onBlur) {
      const actionType = `setCustomCategoryFashion${labelName}Data`;
      const isValidName = `isValidEcommerce${labelName}`;

      const isDuplicate = customCategoriesEcommerceFashionData[
        pluralName
      ].data.find(val => val === value.trim());

      const sanitizeValue = value.split(',')[0].trim();

      if (!isDuplicate && sanitizeValue !== '') {
        this.props.handleIsValidTrue(isValidName);
        dispatch(actItem[actionType](sanitizeValue));
      } else {
        const actionType = `setCustomCategoryFashion${labelName}Input`;
        dispatch(actItem[actionType](''));
      }
    }

    // if user press backspace or delete
    if (
      customCategoriesEcommerceFashionData[pluralName].data.length &&
      e.keyCode === 8 &&
      !customCategoriesEcommerceFashionData[pluralName].input.length
    ) {
      const index =
        customCategoriesEcommerceFashionData[pluralName].data.length - 1;
      this._handleRemoveItem(index, labelName, pluralName);
    }
  };

  _handleRemoveItem = (index, labelName, pluralName) => {
    const { customCategoriesEcommerceFashionData } = this.props;
    const canDeleteDirectly =
      customCategoriesEcommerceFashionData.colors.data.length === 0 ||
      customCategoriesEcommerceFashionData.materials.data.length === 0 ||
      customCategoriesEcommerceFashionData.sizes.data.length === 0 ||
      customCategoriesEcommerceFashionData[pluralName].length - 1 === 0;

    if (canDeleteDirectly) {
      const { dispatch } = this.props;
      const actionType = `unsetCustomCategoryFashion${labelName}Data`;
      dispatch(actItem[actionType](index));
    } else {
      this.setState({
        [`selected${labelName}`]: {
          index,
          name: customCategoriesEcommerceFashionData[pluralName].data[index],
        },
      });
    }
  };

  _onClickInputWrapper = type => {
    this[type].focus();
  };

  _onConfirmDelete = (labelName, isConfirmed) => {
    if (isConfirmed) {
      const { dispatch } = this.props;
      const actionType = `unsetCustomCategoryFashion${labelName}Data`;
      dispatch(actItem[actionType](this.state[`selected${labelName}`].index));
    }
    this.setState({
      selectedColor: null,
      selectedSize: null,
      selectedMaterial: null,
    });
  };

  _onDeleteAll = labelName => {
    const { dispatch, itemVariantsForm } = this.props;
    const actionType = `unsetCustomCategoryFashion${labelName}AllData`;

    dispatch(actItem[actionType]());
    const itemVariantTempModalForm = itemVariantsForm.item_variants.filter(
      itemVariant => !itemVariant.is_generated
    );
    dispatch(arrayRemoveAll('modal_item_variants', 'item_variants'));
    if (itemVariantTempModalForm.length === 0) {
      const initialValue = {
        name: '',
        price: null,
        sku: '',
        in_stock: 0,
        stock_alert: 0,
        cogs: null,
        saved_cogs: false,
        is_saved: false,
        is_editable: true,
        is_new: true,
      };
      dispatch(arrayPush('modal_item_variants', 'item_variants', initialValue));
    } else {
      itemVariantTempModalForm.map(itemVariant =>
        dispatch(arrayPush('modal_item_variants', 'item_variants', itemVariant))
      );
    }

    this.setState({
      selectedColor: null,
      selectedSize: null,
      selectedMaterial: null,
    });
  };

  render() {
    const {
      customCategoriesEcommerceFashion,
      customCategoriesEcommerceFashionData,
    } = this.props;
    const customCategoriesEcommerceFashionFilteredToShow = customCategoriesEcommerceFashion.filter(
      ({ name }) => name === 'color' || name === 'size' || name === 'material'
    );
    return (
      <div className={styles.wrapper}>
        {customCategoriesEcommerceFashionFilteredToShow.map(
          (element, index) => {
            const { name } = element;
            const labelName = name.charAt(0).toUpperCase() + name.slice(1);
            const errName = `isValidEcommerce${labelName}`;
            const pluralName = `${name}s`;
            return (
              <div className="form-group row" key={index}>
                <label
                  htmlFor={`static${labelName}`}
                  className="col-sm-3 col-form-label"
                >
                  {labelName}
                </label>
                <div className={`col-sm-8 ${styles['right-column']}`}>
                  <ul
                    className={`${
                      !this.props[errName] ? styles['error-input'] : ''
                    }   ${styles['input-wrapper-tag']} 
                    }`}
                    onClick={() =>
                      this._onClickInputWrapper(`textInput${name}`)
                    }
                  >
                    {customCategoriesEcommerceFashionData[pluralName].data.map(
                      (item, i) => (
                        <li
                          key={i}
                          className={styles['tag-items']}
                          onClick={() =>
                            this._handleRemoveItem(i, labelName, pluralName)
                          }
                        >
                          <span>{item}</span>
                          <button
                            type="button"
                            className="close"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </li>
                      )
                    )}
                    <input
                      ref={input => {
                        this[`textInput${name}`] = input;
                      }}
                      type="text"
                      id={`static${labelName}`}
                      value={
                        customCategoriesEcommerceFashionData[pluralName].input
                      }
                      maxLength="20"
                      onChange={e => this._handleInputChange(e, labelName)}
                      onKeyDown={e =>
                        this._handleInputKeyDown(
                          e,
                          labelName,
                          pluralName,
                          false
                        )
                      }
                      onBlur={e =>
                        this._handleInputKeyDown(e, labelName, pluralName, true)
                      }
                    />
                  </ul>
                  {customCategoriesEcommerceFashionData[pluralName].data
                    .length > 0 ? (
                    <div className={`${styles['btn-delete-wrapper']}`}>
                      <span
                        className={`${styles['btn-delete']} `}
                        onClick={() => this._onDeleteAll(labelName)}
                        type="button"
                      >
                        <i className="fa fa-times-circle" />
                      </span>
                    </div>
                  ) : null}
                  {!this.props[errName] && (
                    <p> Variant name should not be empty </p>
                  )}
                </div>
                {this.state[`selected${labelName}`] && (
                  <div className={`${styles['confirm-delete-wrapper']}`}>
                    <div>
                      <label>
                        Remove "{this.state[`selected${labelName}`].name}" will
                        also remove all "
                        {`${this.state[`selected${labelName}`].name}`}" on table
                        below.
                      </label>
                      <div
                        className={`${styles['confirm-delete-btn-wrapper']}`}
                      >
                        <button
                          className="btn btn-default"
                          onClick={() =>
                            this._onConfirmDelete(labelName, false)
                          }
                        >
                          Cancel
                        </button>
                        <button
                          className="btn btn-primary"
                          onClick={() => this._onConfirmDelete(labelName, true)}
                        >
                          Confirm
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            );
          }
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    customCategoriesEcommerceFashion,
    customCategoriesEcommerceFashionData,
  } = state.library.item;
  return {
    customCategoriesEcommerceFashion,
    customCategoriesEcommerceFashionData,
    itemForm: getFormValues('item')(state),
    itemVariantsForm: getFormValues('modal_item_variants')(state),
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TypeFieldArrayEcommerce);
